<template>
    <div>
        <el-button type="text" class="underline-button" @click="copy">Copy</el-button>
        <div :class="['select-text', {selected: selected}]">
            <span v-html="note"
                contenteditable="true"
                ref="note">
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'edit-chart',
    props: {
        value: {
            type: String
        },
        selected: {
            type: Boolean
        }
    },

    data() {
        return {
            note: this.value
        }
    },

    mounted() {
        this.$refs.note.addEventListener('input', (event) => {
            this.$emit('input', this.$refs.note.innerHTML)
        })
    },

    methods: {
        copy() {
            let notes = this.$refs.note.innerHTML.replace(/<[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
            if (navigator.clipboard) {
                navigator.clipboard.writeText(notes)
                .then(() => {
                    this.copySuccess()
                })
                .catch((error) => {
                    console.log(error)
                    this.copyFailure()
                })
            }
            else {
                var textArea = document.createElement('textarea')
                textArea.style.display = 'none'
                textArea.value = notes
                document.body.appendChild(textArea)
                textArea.focus()
                textArea.select()

                try {
                    var successful = document.execCommand('copy')
                    if (successful)
                        this.copySuccess()
                }
                catch (err) {
                    this.copyFailure()
                }
                document.body.removeChild(textArea)
                return
            }
        },
        copySuccess() {
            this.$message({
                message: 'Notes copied to clipboard',
                type: 'success'
            });
        },
        copyFailure() {
            console.log('error')
        },
    }
}
</script>

<style lang="scss" scoped>
.select-text {
    height: auto;
    .text-edit {
        font-size: 14px;
        line-height: 18px;
        white-space: pre-line;
        background-color: #ffffff;
        flex-grow: 1;
        height: 130px;
        overflow-y: scroll;
        color: #333333;
        border: none;
    }
    .text-edit:focus {
        outline: none;
    }
}
.underline-button:hover + .select-text {
    border: 2px solid;
}
.underline-button {
    height: 50px;
    margin: 0px 30px 0px 20px;
    color: #4a9bf9;
    font-weight: bold;
    align-self: center;
}
.select-text {
    font-size: 14px;
    line-height: 21px;
    white-space: pre-line;
    background-color: #ffffff;
    padding: 11px;
    flex-grow: 1;
    border-radius: 2px;
    height: 130px;
    overflow-y: scroll;
    box-shadow: 0 0 4px 0 rgba(45, 62, 79, 0.15);
    color: inherit; 
    border: 2px solid rgba(0, 0, 0, 0);
    &>span {
        color: #333333;
        outline: none;
        display: block;
    }
}
.select-text.selected, .underline-button:hover + .text-edit {
    border: 2px solid;
}
.select-text:focus {
    outline: none;
    border: 2px solid;
}
</style>

<style scoped>
.underline-button >>> span {
    border-bottom: 1px solid;
}
</style>